export default {
  common: {
    login: '登入',
    logout: '登出',
    submit: '提交',
    cancel: '取消',
    confirm: '確認',
    save: '保存',
  },
  login: {
    title: '登入',
    email: '電子郵件',
    password: '密碼',
    remember: '記住我',
    forgot: '忘記密碼？',
    error: '電子郵件或密碼無效',
    subtitle: '自動化量化交易系統',
    telegramLogin: '使用 Telegram 登入',
  },
  nav: {
    dashboard: '儀表板',
    trading: '交易',
    settings: '設置',
    message: '消息'
  },
  dashboard: {
    title: '儀表板',
    totalAssets: '總資產',
    dailyPnL: '日收益',
    activeStrategies: '運行中的策略',
    recentTrades: '最近交易',
    running: '運行中',
    paused: '已暫停',
    timeAgo: '{time} 分鐘前'
  },
  trading: {
    title: '交易管理',
    strategyConfig: '策略配置',
    positions: '持倉記錄',
    selectPair: '選擇交易對',
    pleaseSelect: '請選擇',
    strategyType: '策略類型',
    conservative: '保守',
    aggressive: '激進',
    investAmount: '投資金額',
    enterAmount: '請輸入金額',
    startStrategy: '啟動策略',
    closePosition: '平倉',
    conservativeStrategy: '保守策略',
    aggressiveStrategy: '激進策略',
    fillRequired: '請填寫所有必填項',
    strategyStarted: '策略已成功啟動',
    closingPosition: '正在平倉...',
    stopSchedule: '預約停止',
    investMultiplier: '投資倍數',
    estimatedAmount: '預估投資金額: {min} ~ {max} USDT',
    positionAmount: '持倉額',
    profit: '盈利',
    pair: {
      'BTC/USDT': '比特幣/美元',
      'ETH/USDT': '以太坊/美元',
      'BNB/USDT': '幣安幣/美元',
      'SOL/USDT': 'Solana/美元'
    },
  },
  settings: {
    title: '設置',
    language: '語言',
    selectLanguage: '選擇語言',
    apiSettings: 'API 設置',
    apiKey: 'API 密鑰',
    enterApiKey: '請輸入 API 密鑰',
    secretKey: '密鑰',
    enterSecretKey: '請輸入密鑰',
    riskControl: '風險控制',
    maxTradeAmount: '最大交易金額',
    stopLoss: '止損比例',
    notifications: '通知設置',
    tradeNotification: '交易通知',
    riskAlert: '風險預警',
    saved: '設置已保存',
    logoutTitle: '登出確認',
    logoutConfirm: '確定要登出嗎？',
    membership: '會員資訊',
    trial: '試用版',
    basic: '基礎版',
    pro: '專業版',
    premium: '尊享版',
    daysRemaining: '剩餘 {days} 天',
    startTrial: '開始試用',
    trialStarted: '試用已開始',
    purchase: '購買會員',
    tradingPairs: '交易對數量',
    validPeriod: '有效期',
    oneMonth: '一個月',
    unlimited: '不限',
    paymentTitle: '掃碼支付',
    scanToPay: '請使用 USDT-TRC20 掃碼支付',
  },
  message: {
    title: '消息中心',
    notifications: '通知',
    logs: '日誌',
    success: '成功',
    warning: '警告',
    trade: '交易',
    system: '系統',
    strategyStarted: '{pair} 策略已啟動',
    profitTarget: '達到目標收益 {amount}',
    tradingLog: '{pair} {action} @ {price}',
    systemLog: '系統{action}'
  },
  // ... 其他翻譯
} 